<template>
  <portlet
      :icon="'fas fa-chart-line'"
      :title="'Analytics'"
      :actionsBlock="true"
  >
    <template slot="actionsBlock">

      <a @click="fetchData()">

        <button class="btn btn-primary mr-4" style="font-size:15px">
          Data ophalen <i v-if="fetchingData" class="fad fa-spinner fa-spin"></i>
        </button>
      </a>

    </template>

    <template slot="portletBody">
      <!--      {{ customFilters }}-->
      <button class="m-show-lg btn btn-secondary w-100 mb-4" @click="filterOpen = !filterOpen">
        <i class="far mr-3" :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"></i>
        <template v-if="!filterOpen">
          Filter
        </template>
        <template v-else>
          Sluit filter
        </template>
      </button>


      <div class="row dataTable-filters mb-5" :class="filterOpenClass">
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Jaar {{ customFilters.year }} </span>
            </button>
            <div class="dropdown-menu">

              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(year, index) in [new Date().getFullYear(),new Date().getFullYear() -1 , new Date().getFullYear() -2]"
                     :key="year+'-'+index">
                  <input v-model="customFilters.year"
                         :value="year"
                         type="radio"
                         :id="year+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="year+'-'+index">
                    <span>{{ year }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Vestiging </span>
            </button>
            <div class="dropdown-menu">

              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(department, index) in ['Tilburg','Eindhoven','Breda']"
                     :key="department+'-'+index">
                  <input v-model="customFilters.department"
                         :value="department"
                         type="radio"
                         :id="department+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="department+'-'+index">
                    <span>{{ department }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Groupering </span>
            </button>
            <div class="dropdown-menu">

              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(group, index) in ['week','month']"
                     :key="group+'-'+index">
                  <input v-model="customFilters.grouping"
                         :value="group"
                         type="radio"
                         :id="group+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="group+'-'+index">
                    <span>{{ group == 'week' ? "Week" : "Maand" }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Gebruiker </span>
            </button>
            <div class="dropdown-menu">

              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(user, index) in filteredUsers"
                     :key="user.id+'-'+index">
                  <input v-model="customFilters.users"
                         :value="user.id"
                         type="checkbox"
                         :id="user.id+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="user.id+'-'+index">
                    <span>{{ user.displayName }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Type </span>
            </button>
            <div class="dropdown-menu">

              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(placement, index) in ['active','starters','stoppers',]"
                     :key="placement+'-'+index">
                  <input v-model="customFilters.placement"
                         :value="placement"
                         type="checkbox"
                         :id="placement+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="placement+'-'+index">
                    <span><div
                        :style="`display:inline-block;width:15px;height:15px;border-radius:50px;background:${colors[placement]}`"/> {{
                        getTitleOfPlacement(placement)
                      }}
                      </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <a @click="hideNamesInChart = !hideNamesInChart">

            <button class="btn btn-primary mr-4">
              {{ !hideNamesInChart ? 'Verberg' : 'toon' }} namen
            </button>
          </a>
        </div>

      </div>
      <hr>
      <div v-if="chartData">
        <div style="max-height:750px;">
          <AnalyticsChart :width="300" :height="750" :chartdata="getChartData"
                          :options="getChartOptions"></AnalyticsChart>
        </div>

        <!--      <VueApexCharts :options="getChartOptions"-->
        <!--                     :series="getChartData"></VueApexCharts>-->
        <!--        <pre>-->

        <!--        {{ getChartData }}-->
        <!--        </pre>-->
      </div>
    </template>

  </portlet>
</template>

<script>
import {mapGetters} from 'vuex';
import {getGeoLocation} from '../../components/mixins/getGeoLocation';
import {dataTables} from '../../components/mixins/dataTables';
import {swalModals} from '../../components/mixins/swalModals.js';
import {Can} from '../../../permission/ability.js';
import {RIGHTS} from '../roles/rights';
import store from "@/store";
import Vue from "vue";
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
import AnalyticsChart from "@/components/AnalyticsChart.vue";

export default {
  components: {VueApexCharts, AnalyticsChart},
  mixins: [getGeoLocation, dataTables, swalModals],
  data() {
    return {
      isAdmin: false,
      users: [],
      fetchingData: false,
      filterOpen: false,
      filterOpenClass: 'm-hide-lg',
      chartData: null,
      colors: {
        starters: '#027f7e',
        active: "#9a8407",
        stoppers: '#640000',
        cumulative:{
          starters: '#03afae',
          active: "#b79d03",
          stoppers: '#960000',
        },
        cumulativeLastyear:{
          starters: '#3b8180',
          active: "#50471b",
          stoppers: '#774444',
        }
      },
      hideNamesInChart: false,
      customFilters: {
        year: moment().year(),
        grouping: "week",
        users: [],
        department: "Tilburg",
        placement: ['active', 'starters', 'stoppers']
      },

      placementFilterTranslation: {
        'active': "actieve plaatsingen",
        'stoppers': "stoppers",
        'starters': "starters"
      }
    }

  },
  methods: {
    Can,
    async getUsers(name) {

      this.$store.commit('setLoading', true)
      await store.dispatch('users/getAllUsers', {
        ApiClient: Vue.prototype.$ApiClient,
        departments: this.$store.getters.getUserData.departments
      }).then((res) => {
        if (res.status === 200) {

          this.users = res.data.users.filter(user => user.hasOwnProperty('email'));
          this.nextPageToken = res.nextToken;
          this.$store.commit('setLoading', false)
        }
      }).catch((err) => {
        this.$store.commit('setLoading', false)

      });

      this.$store.commit('setLoading', false)
    },
    async fetchData() {
      this.fetchingData = true
      let data = await axios.post(this.$CLOUD_API + '/analytics', {
        // let data = await axios.post( 'http://localhost:9872/workfix/europe-west1/api-http/analytics/',{

            ...this.customFilters,
            firebaseIdToken: localStorage.getItem('firebaseToken')
          }
      )
      this.fetchingData = false
      this.chartData = data.data

    },
    getTitleOfPlacement(placement = undefined) {
      placement = placement ? placement : this.customFilters.placement

      return this.placementFilterTranslation[placement]
    }
  },
  computed: {
    filteredUsers() {
      return _.filter(this.users, user => {
        return user.roles[this.customFilters.department] != null
      })
    },
//     getChartOptions() {
//       const options = {
//         chart: {
//           height: 450,
//           type: 'bar',
//           stacked: true,
//
//           toolbar: {
//             show: true,
//           },
//         },
//         stroke: {
//           width: 1,
//           colors: ['#fff']
//         },
//         xaxis: {
//           type: 'datetime',
//           // min: new Date('01 Mar 2012').getTime(),
//           tickAmount: 6,
//
//         },
//         colors: ['#80c7fd', '#008FFB', '#80f1cb', '#00E396'],
//         plotOptions: {
//           bar: {
//             horizontal: false,
//           },
//         },
//
//         tooltip: {
//           enabled: true,
//           enabledOnSeries: true,
//           shared: true,
//           followCursor: false,
//           intersect: false,
//           inverseOrder: false,
//           // custom: undefined,
//           hideEmptySeries: true,
//           fillSeriesColor: false,
//           theme: false,
//           style: {
//             fontSize: '12px',
//             fontFamily: undefined
//           },
//           onDatasetHover: {
//             highlightDataSeries: false,
//           },
//           // x: {
//           //   show: true,
//           //   format: 'dd MMM',
//           //   formatter: (seriesName, a, b) => {
//           //     console.log(1, seriesName, a, b)
//           //     return seriesName
//           //   }
//           // },
//           y: {
//             formatter: (value, a, b) => {
//               console.log(value, a, b)
//               console.log(this.getChartData[a.seriesIndex].group, this.getChartData[a.seriesIndex].name)
//               let string = `${this.getChartData[a.seriesIndex].group}: ${value}`
//               return string
//             },
//             // title: {
//             //   formatter: (seriesName, a, b) => {
//             //
//             //     return seriesName
//             //   },
//             // },
//           },
//           fixed: {
//             enabled: false,
//             position: 'topRight',
//             offsetX: 0,
//             offsetY: 0,
//           },
//         },
//
//         legend: {
//           position: 'top',
//         },
//         fill: {
//           opacity: 1,
//         },
//       };
//
// // Set x-axis categories based on sorted customers
// //       options.xaxis.categories = this.chartData.customers;
//
// // Log the formatted series and options for verification
//
//       return options
//     }
    getChartData() {

      let placements = this.chartData.placements
      let cummulative = this.chartData.cummulativePlacements
      let cummulativeLastYear = this.chartData.lastYearsPlacements
      let datasets = [{
        type: 'line',
        label: 'Cumulatief Starters',
        data: _.map(cummulative.starters, (value, key) => {
          return {x: key, y: value}
        }),
        fill: false,
        borderColor: this.colors.cumulative.starters,
        // backgroundColor: 'rgba(0, 99, 132, 0.2)',
        pointStyle:'circle',
        borderWidth: 2,
        borderDash: [10,5],
        hidden: true,
      },
        {
          type: 'line',
          label: 'Cumulatief Stoppers',
          data: _.map(cummulative.stoppers, (value, key) => {
            return {x: key, y: value}
          }),
          fill: false,
          borderColor: this.colors.cumulative.stoppers,
          // backgroundColor: 'rgba(0, 99, 132, 0.2)',
          pointStyle:'circle',
          borderWidth: 2,
          borderDash: [10,5],
          hidden: true,
        },
        {
          type: 'line',
          label: 'Cumulatief starters afgelopen jaar',
          data: _.map(cummulativeLastYear.starters, (value, key) => {
            return {x: key, y: value}
          }),
          fill: false,
          borderColor: this.colors.cumulativeLastyear.starters,
          pointStyle:'triangle',
          // backgroundColor: 'rgba(0, 99, 132, 0.2)',
          borderWidth: 3
        },
        {
          type: 'line',
          label: 'Cumulatief stoppers afgelopen jaar',
          data: _.map(cummulativeLastYear.stoppers, (value, key) => {
            return {x: key, y: value}
          }),
          fill: false,
          borderColor: this.colors.cumulativeLastyear.stoppers,
          pointStyle:'triangle',
          // backgroundColor: 'rgba(0, 99, 132, 0.2)',
          borderWidth: 3
        }]

      for (const typeOfPlacement in placements) {
        if (_.includes(this.customFilters.placement, typeOfPlacement)) {
          let usersInType = placements[typeOfPlacement]

          for (const userName in usersInType) {
            let datesWithValues = usersInType[userName]
            let mappedData = _.map(datesWithValues, (value, key) => {
              return {x: key, y: value}

              return {x: key, y: value.length + 1}

            })
            let dataSetToPush = {
              type: 'bar',
              label: typeOfPlacement,
              data: mappedData,
              stack: userName,
              // categoryPercentage: 1,
              backgroundColor: this.colors[typeOfPlacement]
            }

            // console.log(typeOfPlacement, ' values for', userName, datesWithValues)
            datasets.push(dataSetToPush)
          }
        }
      }

      let labels = this.getLabels
      return {
        labels: labels,
        datasets,

      }
    },
    getLabels() {
      let dateRange = this.chartData.dateRange
      let customFilter = this.customFilters.grouping

      let labels = this.chartData.populatedRange
      labels = _.map(labels, l => {
        if (customFilter == 'week') {
          return 'week ' + l
        }
        if (customFilter == 'month') {
          return moment().set({month: l}).format('MMM')
        }
        return l
      })


      return labels

      const dateArray = [];
      let currentDate = new Date(dateRange.min);

      while (currentDate <= new Date(dateRange.max)) {
        dateArray.push(new Date(currentDate).toISOString().split('T')[0]);
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateArray;
    },
    getChartOptions() {
      const self = this

      const unitFormat = self.customFilters.grouping
      const formatting = unitFormat == 'week' ? "DD-MM" : "MM"
      let testing = self.hideNamesInChart
      return {
        animation: {
          duration: 0,
        },
        plugins: {
          beforeInit: function (chart, options) {
            chart.legend.afterFit = function () {
              this.height = this.height + 50;
            };
          },
          datalabels: {
            anchor: 'end',
            align: 'top',
            rotation: -90,
            color: 'black',
            formatter: function (value, context) {
              let ds = context.chart.data.datasets;
              let stack = ds[context.datasetIndex].stack;
              // Check if this is the topmost dataset in its stack
              let isTopMost = true;
              if (self.hideNamesInChart) {
                return ''
              }
              for (let i = context.datasetIndex + 1; i < ds.length; i++) {
                if (ds[i].stack === stack) {
                  isTopMost = false;
                  break;
                }
              }
              if (stack) {
                return isTopMost ? stack : '';

              } else {
                return ''
              }
              // If it's the topmost dataset in the stack, return the stack label, otherwise return an empty string
            }
          },

        },
        responsive: true,
        maintainAspectRatio: false,
        height: 500,
        interaction: {
          intersect: false,
        },
        tooltips: {
          mode: 'point',
          callbacks: {
            // title: function (tooltipItem, chart) {
            //   // Return an empty string to skip the default label
            //   return '';
            // },
            // label: function (tooltipItem, chart) {
            //   // Return an empty string to skip the default label
            //   return '';
            // },
            // afterLabel: function (tooltipItem, chart) {
            //   const datasets = chart.datasets;
            //   const datasetIndex = tooltipItem.datasetIndex;
            //   const stack = datasets[datasetIndex].stack; // Get the stack group of the current dataset
            //   let cumulativeSum = 0;
            //
            //   // Iterate over each dataset
            //   datasets.forEach((dataset) => {
            //     // Check if the dataset is part of the same stack group
            //     if (dataset.stack === stack) {
            //       // Add the value if the data point exists
            //       if (dataset.data[tooltipItem.index] && dataset.data[tooltipItem.index].y) {
            //         cumulativeSum += dataset.data[tooltipItem.index].y;
            //       }
            //     }
            //   });
            //
            //   return `Totaal: ${cumulativeSum}`;
            // }
          }
        },
        scales: {
          // xAxes: [
          //   {
          //     gridLines: {
          //       display: true
          //     },
          //     barThickness: 20,
          //     maxBarThickness: 20,
          //     barPercentage: 3.0,
          //     categoryPercentage: 3.0,
          //     offset: false, // IF this i
          //     stacked: false,
          //     type: 'time',
          //     // bounds: 'ticks',
          //     ticks: {
          //       autoSkip: false,
          //       min: this.chartData.dateRange.min,
          //       max: this.chartData.dateRange.max
          //     },
          //     time: {
          //       isoWeekday: true,
          //       unit: unitFormat,
          //       // round: unitFormat,
          //       // stepSize: 1,
          //       displayFormats: {
          //         millisecond: formatting, //I have tried without the 'a' too, same result
          //         second: formatting,
          //         minute: formatting,
          //         hour: formatting,
          //         day: formatting,
          //         week: formatting,
          //       }
          //     }
          //   }],
          x: {
            barThickness: 40,
            maxBarThickness: 40,
            barPercentage: 3.0,
            categoryPercentage: 33.0,
            ticks: {
              padding: 100,
              callback: function (value, index, values) {
                return '123$' + value;
              }
            },
            stacked: false,
            offset: true,
          },

          y: {
            beginAtZero: true,
            stacked: true
          }
        },
        legend: {
          labels: {
            filter: function (item, data) {
              if (item.datasetIndex > 3) {
                let stack = data.datasets[item.datasetIndex].stack
                item.text = item.text += ` - ${stack}`
              }
              return item
            }
          }
        }
      }

    }


  },
  created() {
    this.users = this.getUsers()
  }
}
;
</script>
<style lang="scss" scoped>
/deep/ .progress {
  background: #b4b4b4;
}

/deep/ .progress-bar {

  span {
    margin: 5px;
    padding: 2px;
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
}

/deep/ .custom-control-input:indeterminate ~ .custom-control-label:before {
  background: darkgrey;
}

/deep/ .chartjs-tooltip-key {
  display: none;
}

</style>